const accordions = document.querySelectorAll(".accordion");

accordions.forEach((accordion) => {
	const buttons = accordion.querySelectorAll("button");
	const paragraphButtons = accordion.querySelectorAll("p[type=button]");

	buttons.forEach((button) => {
		$(button).on("keydown", (e) => {
			if (e.key == "Enter") {
				$(e.target).find("p[type=button]").click();
			}
		});
	});

	$(paragraphButtons).on("click", (e) => {
		const targetParent = e.target.parentElement;

		paragraphButtons.forEach((btn) => {
			const buttonParent = btn.parentElement;

			buttonParent.addEventListener(
				"transitionstart",
				() => (btn.disabled = true)
			);
			buttonParent.addEventListener(
				"transitionend",
				() => (btn.disabled = false)
			);

			if (btn !== e.target && $(buttonParent).hasClass("show")) {
				$(buttonParent).removeClass("show");
			}
		});

		$(targetParent).toggleClass("show");
	});
});
